import { createSlice } from '@reduxjs/toolkit';

import storage from '../../helpers/storage';

export const companiesSlice = createSlice({
  name: 'companiesSlice',
  initialState: {
    openAddBillingAddressModal: storage.get('user')
      ? !JSON.parse(storage.get('user') as string)?.company?.billingAddress
      : false,
  },
  reducers: {
    setOpenAddBillingAddressModal: (state, action) => {
      state.openAddBillingAddressModal = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setOpenAddBillingAddressModal } = companiesSlice.actions;
export const { reducer: companiesReducer } = companiesSlice;
